export default __webpack_public_path__ + "83923eaa0464a3ef78c8e6b23d24ae03.png";